import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_USER';

export async function createUser(
    userToken: string,
    user: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/users/`,
            data: user,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de création d\'un user',
            error
        });
    }
}
